import { memo } from "react"

const GRID_BACKGROUND_STYLE = {
  backgroundImage:
    "linear-gradient(to right, rgba(11,26,59,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(11,26,59,0.05) 1px, transparent 1px)",
  backgroundSize: "72px 72px",
  maskImage:
    "radial-gradient(ellipse 85% 65% at 50% 50%, #000 20%, transparent 80%)",
  WebkitMaskImage:
    "radial-gradient(ellipse 85% 65% at 50% 50%, #000 20%, transparent 80%)",
  opacity: 0.5,
} as const

export const HeroBackground = memo(function HeroBackground() {
  return (
    <div
      className="absolute inset-1 overflow-hidden rounded-sm md:inset-1.5"
      aria-hidden="true"
    >
      <div className="absolute inset-0 bg-mesa-bg" />
      <div className="absolute inset-0" style={GRID_BACKGROUND_STYLE} />
    </div>
  )
})
